import { request } from "./../helper/request";
import { trans } from "./../helper/trans";
import { lang, urlId, status } from "./../app";
import { notify } from "./../helper/notify";
import { presentBlurbs } from "./../helper/presentBlurbs";
import { buildGicEditor } from "./../helper/buildGicEditor";
import { presentGicItems } from "./../helper/presentGicItems";

import "./../img/cr_hero_wide.jpg";
import "./../img/cr_hero.jpg";

window.renderContent = async user => {
	const userLevel = user.userLevel.toLowerCase();
	const admin = userLevel === "admin" || userLevel === "qa";
	const author = `${user.gacUser.firstname} ${user.gacUser.lastname}`;
	const reqId = admin ? "c6148d32-343e-4918-b0fb-53982f7412e0" : "644bff17-8cd7-46ea-b103-8d98ac019eaa";
	try {
		const response = await request({
			reqId: reqId,
			datatype: "crItem",
			filter: admin ? "" : "#langs.#lang.#pubDate <= :now AND #langs.#lang.#status = :true",
			valuesAdd: admin
				? ""
				: {
						":now": new Date().getTime(),
						":true": true
				  },
			namesAdd: admin
				? ""
				: {
						"#langs": "langs",
						"#lang": lang,
						"#pubDate": "pubDate",
						"#status": "status"
				  }
		});
		presentBlurbs(response, author, userLevel, false, urlId);
	} catch (err) {
		console.error("Error fetching Corporate Responsibility items:", err);
		notify(trans("error"), "danger");
	}
	// blurbs are fetched and presented

	let cr;
	try {
		let response = await request({
			reqId: reqId,
			datatype: "pdf",
			filter: "contains (#autoList, :cr)",
			namesAdd: {
				"#autoList": "autoList"
			},
			valuesAdd: {
				":cr": "cr"
			}
		});
		let langCrs = response.filter(item => item.langs && item.langs[lang]);
		if (langCrs.length) {
			langCrs = langCrs.sort(function (a, b) {
				const aVal = a.langs[lang].uploaded;
				const bVal = b.langs[lang].uploaded;
				return aVal > bVal ? -1 : aVal < bVal ? 1 : 0;
			});
		}
		cr = langCrs.length ? langCrs[0] : "";
		if (cr && cr.langs[lang] && cr.langs[lang].link) {
			let crLink = cr.langs && cr.langs[lang] ? cr.langs[lang].link : "";
			let crId = cr.id ? cr.id : "";
			$("#cr_factsheet_buttons").attr("data-id", crId).find("a").attr("href", crLink);
			$("#download_cr_facts_button").removeClass("hidden");
		}
	} catch (err) {
		console.error("Error fetching Gulfstream Corporate Responsibility document:", err);
		notify(trans("error"), "danger");
	}
	// CR Fact Sheets are fetched and presented

	try {
		let response = await request({
			reqId: reqId,
			datatype: "gic"
		});
		window.gicItems = response;
		if (userLevel === "admin") {
			$("#gic_header").append(`<span data-button="gic editor" class="uk-margin-small-left" uk-icon="icon: plus-circle;"></span>`);

			$("[data-button='gic editor']").on("click", function () {
				$("#gic_editor_wrapper").removeClass("hidden");
				buildGicEditor(null, author, userLevel);
			});
		}
		presentGicItems(author, userLevel);
	} catch (err) {
		console.error("Error fetching Gulfstream In The Community items:", err);
		notify(trans("error"), "danger");
	}
	// In the News items are fetched and presented
};
